"use client";

import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";

const Testimonials = () => {
  return (
    <section className="py-20 px-6 bg-secondary/30">
      <div className="container max-w-6xl mx-auto">
        <SectionHeading title="Testimonials" />
        
        <div className="flex justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true, margin: "-100px" }}
            className="max-w-2xl text-center"
          >
            <Card className="border border-border bg-card/50 backdrop-blur-sm">
              <CardContent className="pt-6">
                <p className="text-lg italic mb-6">
                  &ldquo;Testimonials coming soon. Let&apos;s work together and create something extraordinary.&rdquo;
                </p>
                <div className="flex items-center justify-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-accent/20"></div>
                  <div>
                    <p className="font-medium">Your Name</p>
                    <p className="text-sm text-muted-foreground">Your Company</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
